// @ts-nocheck
import FilterAltTwoToneIcon from '@mui/icons-material/FilterAltTwoTone';
import { Box, IconButton } from '@mui/material';
import { useCallback } from 'react';
import PropTypes from 'prop-types';

const ColumnHeaderWithFilter = ({ children, onFilterClick, columnLabel }) => {
  const handleFilterIconClick = useCallback(
    (e) => {
      e.stopPropagation();
      e.preventDefault();
      onFilterClick?.({
        columnLabel,
      });
    },
    [onFilterClick, columnLabel]
  );
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      sx={{
        '&:hover .FilterIcon': {
          visibility: 'visible',
        },
      }}
    >
      {children}

      <IconButton
        className="FilterIcon"
        size="small"
        aria-label="open-column-filter"
        onClick={handleFilterIconClick}
        sx={{
          visibility: 'hidden',
        }}
      >
        <FilterAltTwoToneIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

ColumnHeaderWithFilter.propTypes = {
  children: PropTypes.node.isRequired,
  onFilterClick: PropTypes.func,
  columnLabel: PropTypes.string.isRequired,
};

export default ColumnHeaderWithFilter;
